import Dialog from '../Dialog';

export const YesNoDialog = ({
  isOpen,
  title,
  message,
  onYesClick,
  onNoClick,
  onClose,
  loading
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      title={title}
      message={message}
      primaryText="YES"
      onPrimaryClick={onYesClick}
      secondaryText="NO"
      onSecondaryClick={onNoClick}
      onClose={onClose}
      loading={loading}
    />
  );
};
